import { SvgProps } from "components/icons/types";

export const Exclamation = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_4966_8103)">
      <path
        d="M15.414 4.10067L11.8993 0.585333C11.5213 0.208 11.0187 0 10.4853 0H5.51533C4.982 0 4.47933 0.208 4.10067 0.586L0.586 4.10067C0.208667 4.47867 0 4.98067 0 5.51467V10.4853C0 11.0193 0.208 11.5213 0.586 11.8993L4.10067 15.4147C4.47867 15.792 4.98133 16 5.51467 16H10.4847C11.018 16 11.5207 15.792 11.8993 15.414L15.4133 11.8993C15.7907 11.5213 15.9993 11.0193 15.9993 10.4853V5.51467C15.9993 4.98067 15.7913 4.47867 15.414 4.10067ZM14.6667 10.4853C14.6667 10.6607 14.596 10.8327 14.4713 10.9567L10.9573 14.4707C10.8307 14.5967 10.6627 14.6667 10.4847 14.6667H5.51467C5.33667 14.6667 5.16867 14.5973 5.04267 14.4713L1.52867 10.9567C1.404 10.832 1.33333 10.6607 1.33333 10.4853V5.51467C1.33333 5.33933 1.404 5.16733 1.52867 5.04333L5.042 1.52933C5.16867 1.40333 5.33667 1.33333 5.51467 1.33333H10.4847C10.6627 1.33333 10.8307 1.40267 10.9567 1.52867L14.4707 5.04333C14.5953 5.168 14.666 5.33933 14.666 5.51467L14.6667 10.4853ZM8.66667 8.66667H7.33333V4H8.66667V8.66667ZM9 11C9 11.552 8.552 12 8 12C7.448 12 7 11.552 7 11C7 10.448 7.448 10 8 10C8.552 10 9 10.448 9 11Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4966_8103">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
